module.exports = "../images/walleye-schooling-habits.jpg?v=fa03c15";